module.exports = __webpack_public_path__ + "img/title.0d98bcab.svg";